import {Component, inject, OnDestroy, OnInit, signal} from '@angular/core';
import {DatePipe, TitleCasePipe} from '@angular/common';
import {Modal} from '../../../shared/components/modal/modal';
import {ReleaseNotesService} from './release-notes.service';
import {ReleaseNote} from './release-notes.data';
import {ButtonComponent} from '../../../shared/components/button/button.component';

@Component({
  selector: 'app-release-notes-modal',
  imports: [Modal, DatePipe, TitleCasePipe, ButtonComponent],
  templateUrl: './release-notes-modal.html',
})
export class ReleaseNotesModal implements OnInit, OnDestroy {
  private service = inject(ReleaseNotesService);
  private openTimeout?: ReturnType<typeof setTimeout>;

  notes = signal<ReleaseNote[]>([]);
  isOpen = signal(false);

  protected readonly isArray = Array.isArray;

  ngOnInit(): void {
    this.notes.set(this.service.getNewReleaseNotes());

    if (this.notes().length > 0) {
      this.openTimeout = setTimeout(() => this.isOpen.set(true), 400);
    }
  }

  close(): void {
    this.isOpen.set(false);
    this.service.markAsSeen();
  }

  ngOnDestroy(): void {
    clearTimeout(this.openTimeout);
  }
}
